export class AppUtils {

  /**
   * 
   * @param value enum value
   * @param enumObj enum object that who has keys and values
   * @returns 
   * @description to get enum key name as string
   */
  public static mapEnumKey<T extends Record<string | number, string | number>>(value: keyof T | T[keyof T], enumObj: T): keyof T {

    const key = typeof value === 'number'
    ? enumObj[value]
    : value;

    return key?.toString()?.toLowerCase() as keyof T;
    
  }

  /**
   * 
   * @param value enum key/value
   * @param enumObj enum object that who has keys and values
   * @returns 
   * @description to get enum key value
   */
  public static mapEnumValue<T extends Record<string, string | number>>(value: keyof T | T[keyof T],  enumObj: T): T[keyof T] {
    
    value = typeof value === 'string'
    ? enumObj[value]
    : value

    return value as T[keyof T];

  }

  /**
   * @method combineContext
   * @description Combines two contexts into a merged object.
   */
  public static combineContext<T, U>(data1: T, data2: U): T & U {
    return { ...data1, ...data2 };
  }

  /**
   * 
   * @param object - The object to chain
   * @returns The result of the chaining
   */
  public static chainReducerFn<T extends object, TResult = unknown>(object: T): TResult {
    return Object.keys(object).reduce((acc: any, curr) => acc[curr], object ?? {});
  }

  /**
   * @method chainByReducerFn
   * @description Chains a list of keys to an object and returns the result
   * @param chain - The list of keys to chain
   * @param value - The object to chain
   * @returns The result of the chaining
   */
  public static chainByReducerFn<T extends object, TResult = unknown>(chain: string | string[], value: T): TResult {
    
    // validate chain
    let _keys = Array.isArray(chain) ? chain : chain.split('.');

    // if keys is empty, return value
    if (_keys.length === 0) return value as unknown as TResult;
    
    return _keys.reduce((acc: any, curr) => acc ? acc[curr] : undefined, value ?? {});
  }
  
  /**
   * @method generatePassword
   * @description Generates a random password
   * @param len - The length of the password
   * @returns The generated password
   */
  public static generatePassword(len = 12): string {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    len = Math.max(len, 8);
    return Array.from({ length: len }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  }

}